export default {
    formId: 'createCustomerForm', //'checkoutForm',
    formField: {
      name: {
        name: 'name',
        label: 'Nombre cliente*',
        requiredErrorMsg: 'El nombre cliente es requerido.'
      },
      address: {
        name: 'address',
        label: 'Direccion cliente*',
        requiredErrorMsg: 'La direccion es requerida.'
      },
      email: {
        name: 'email',
        label: 'Email*',
        requiredErrorMsg: 'El email es requerido.'
      },
      person_in_charge: {
        name: 'person_in_charge',
        label: 'Persona responsable*',
        requiredErrorMsg: 'La resposana responsable es requerida.'
      },
      contact: {
        name: 'contact',
        label: 'Contacto persona responsable*',
        requiredErrorMsg: 'La persona responsable es requerida.',
        typeDataMsg: 'El campo es numerico.'
      },
      second_person_in_charge: {
        name: 'second_person_in_charge',
        label: 'Segunda persona responsable',
        requiredErrorMsg: ''
      },
      second_customer_contact: {
        name: 'second_customer_contact',
        label: 'Contacto segunda persona responsable',
        requiredErrorMsg: '',
        typeDataMsg: 'El campo es numerico.'
      },
      phone: {
        name: 'phone',
        label: 'Telefono fijo cliente*',
        requiredErrorMsg: 'El telefono cliente es obligatorio.'
      },
      start_date: {
        name: 'start_date',
        label: 'Fecha inicio*',
        requiredErrorMsg: 'La fecha de inicio es obligatoria.'
      },
      status: {
        name: 'status',
        label: 'Cliente activo*',
        requiredErrorMsg: 'El estado es obligatorio.'
      },
      country: {
        name: 'country',
        label: 'Pais*',
        requiredErrorMsg: 'El pais es requerido.',
      },
      departament: {
        name: 'departament',
        label: 'Departamento*',
        requiredErrorMsg: 'El departamento es requerido.'
      },
      municipaly: {
        name: 'municipaly',
        label: 'Municipio*',
        requiredErrorMsg: 'El municipio es requerido.',
      },
      applications: {
        name: 'applications',
        label: 'Aplicaciones*',
        requiredErrorMsg: 'Debes selecionar por lo menos una aplicacion.',
      },
      has_trial: {
        name: 'has_trial',
        label: '¿Tiene periodo de prueba?',
        requiredErrorMsg: ''
      },
      trial_ends_at: {
        name: 'trial_ends_at',
        label: 'Fin de periodo de prueba',
        requiredErrorMsg: 'La fecha de fin de prueba es requerida.'
      },
      subscription_ends_at: {
        name: 'subscription_ends_at',
        label: 'Fecha de pago',
        requiredErrorMsg: 'La fecha de pago es requerida.'
      },
    }
  };
  